import env from "../config.json";

export const NODE_ENV = env.NODE_ENV;
export const STORAGE_KEY_PREFIX = "yp_";
export const UNSTRUCTURED_API_KEY = "";
export const API_BASE_URL = env.API_BASE_URL;
export const ADDIN_BASE_URL = env.ADDIN_BASE_URL;
export const ADDIN_VERSION = env.VERSION;
export const LOG_LEVEL = env.LOG_LEVEL || "debug";
export const UNSTRUCTURED_API_URL = "";
export const POSTHOG_PUBLIC_HOST = "https://us.i.posthog.com";
export const POSTHOG_API_KEY = "phc_I3kQdMec7txvDvn65URaUarIlkQPlarR6RzBTjP1Oi3";
export const SENTRY_DSN =
  "https://1fa4242cc2020b14542ba5cf8d270b49@o4507108552605696.ingest.us.sentry.io/4509151137497088";
export const FUZZY_MATCH_CONFIDENCE_THRESHOLD = 0.6;
export const PARAGRAPH_LOCATION_INTERVAL = 8;
export const NGRAM_ROLLING_WINDOW_SIZE = 10;
export const REANALYSE_REDLINE_ON_FUZZY_MATCH = env.REANALYSE_REDLINE_ON_FUZZY_MATCH ?? false;
export const LOGTAIL_SYNC_ENABLED = NODE_ENV !== "development";
export const DEFAULT_CUSTOMER_RULE_ID = "default-customer-rule";
